import { useCurrentUser } from '@query'

export interface LucaUsageVisibilityInput {
  agencyId?: number | null
}

export const resolveLucaUsageVisibility = ({ agencyId }: LucaUsageVisibilityInput): boolean =>
  !agencyId

export const useLucaUsageVisibility = (): { showLucaUsage: boolean } => {
  const { data: user } = useCurrentUser()

  // A missing user is not the same as a user with no agency. Treating it as
  // visible mounts Luca usage and requests it before membership can be known.
  if (!user) {
    return { showLucaUsage: false }
  }

  return {
    showLucaUsage: resolveLucaUsageVisibility({
      agencyId: user.agency_id
    })
  }
}
